import { FC } from 'react'
import {
  AmericanExpressIcon,
  DiscoverIcon,
  MasterCardIcon,
  VisaIcon,
  CreditCardIcon,
  CreditCardImage,
} from 'components/images'

export type CardType = 'visa' | 'mastercard' | 'amex' | 'discover' | undefined

export interface KCardIconProps {
  cardType?: string
  useGenericImage?: boolean
}

export const KCardIcon: FC<KCardIconProps> = ({
  cardType,
  useGenericImage = false,
}) => {
  switch (cardType?.toLowerCase()) {
    case 'visa':
      return <VisaIcon />
    case 'mastercard':
      return <MasterCardIcon />
    case 'amex':
      return <AmericanExpressIcon />
    case 'discover':
      return <DiscoverIcon />
    default:
      return useGenericImage ? <CreditCardImage /> : <CreditCardIcon />
  }
}
